/**
 * region-nav
 */

// Module dependencies
import 'protons';

// Module styles
import './_region-nav.scss';

// Module template
import './_region-nav.twig';

export const name = 'region-nav';

export const defaults = {
  dummyClass: 'js-region-nav-exists',
};

/**
 * Drupal Behaviors for region navigation.
 */
Drupal.behaviors.regionNav = {
  attach(context) {
    const submenuToggles = once(
      'region-nav-submenu',
      context.querySelectorAll('.js-region-toggle')
    );
    const regionNavToggles = once(
      'region-nav-toggle',
      context.querySelectorAll('.js-all-regions-toggle')
    );

    // Function to handle submenu toggle
    function toggleSubList(e) {
      e.stopPropagation();
      e.preventDefault();
      const el = e.currentTarget;
      const menuItem = el.parentElement.parentElement;

      if (menuItem.classList.contains('region-nav__current')) {
        menuItem.parentElement.classList.toggle('region-nav--open');
      } else {
        menuItem.classList.toggle('region-nav__region--open');
      }
    }

    // Attach event listeners for submenu toggles
    submenuToggles.forEach((toggle) => {
      toggle.addEventListener('click', toggleSubList);
    });

    // Attach event listeners for region navigation toggle
    regionNavToggles.forEach((toggle) => {
      if (!toggle.classList.contains('toggler')) {
        toggle.classList.add('toggler');
        toggle.addEventListener('click', () => {
          const regionNav = context.querySelector('.region-nav');
          regionNav.classList.toggle('region-nav--open');
          document.body.classList.toggle('js-scroll-lock');
        });
      }
    });
  },
};

export default Drupal.behaviors.regionNav;
